// FILE: src/pages/NotFoundPage.jsx
import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import PublicLayout from "../layouts/PublicLayout";

export function homeFor(role) {
  if (role === "admin") return { to: "/admin", label: "Go to the admin dashboard" };
  if (role === "student") return { to: "/student", label: "Go to my dashboard" };
  return { to: "/login", label: "Go to sign in" };
}

export default function NotFoundPage() {
  const role = useSelector((s) => s.auth.role);
  const home = homeFor(role);
  return (
    <PublicLayout>
      <Card sx={{ borderRadius: 4 }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography sx={{ color: "text.secondary", fontWeight: 600, mb: 1 }}>Error 404</Typography>
          <Typography variant="h1" sx={{ mb: 1 }}>
            We can't find that page
          </Typography>
          <Typography sx={{ color: "text.secondary", mb: 3 }}>
            The link may be old or mistyped. Your progress is safe.
          </Typography>
          <Button component={RouterLink} to={home.to} variant="contained" size="large">
            {home.label}
          </Button>
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
